import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import DashboardLayout from './components/DashboardLayout.jsx';
import FyersTokenGuard from './components/FyersTokenGuard.jsx';
import ProtectedRoute from './components/ProtectedRoute.jsx';
import { AppProvider } from './context/AppContext.jsx';
import BrokersPage from './pages/BrokersPage.jsx';
import FyersCallbackPage from './pages/FyersCallbackPage.jsx';
import FyersLoginPage from './pages/FyersLoginPage.jsx';
import LoginPage from './pages/LoginPage.jsx';
import OverviewPage from './pages/OverviewPage.jsx';
import RiskPage from './pages/RiskPage.jsx';
import StrategiesPage from './pages/StrategiesPage.jsx';
import UsersPage from './pages/UsersPage.jsx';

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          <Route
            path="/fyers/login"
            element={
              <ProtectedRoute>
                <FyersLoginPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/fyers/callback"
            element={
              <ProtectedRoute>
                <FyersCallbackPage />
              </ProtectedRoute>
            }
          />

          <Route
            element={
              <ProtectedRoute>
                <FyersTokenGuard>
                  <DashboardLayout />
                </FyersTokenGuard>
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<OverviewPage />} />
            <Route path="/users" element={<UsersPage />} />
            <Route path="/brokers" element={<BrokersPage />} />
            <Route path="/strategies" element={<StrategiesPage />} />
            <Route path="/risk" element={<RiskPage />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
